import React from "react";
import {
   MARITAL_STATUS_OPTIONS,
   EMPLOYMENT_STATUS_OPTIONS,
   YES_NO_CHOICE_OPTIONS,
   TITLE_OPTIONS, TITLE_OPTIONS_WITH_PLACEHOLDER
} from "@constants/dropdown-choices";

import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import {isEmployed} from "@functions/employments";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";

import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import {ValidateStep1Data} from "@validators/motor-cycle-insurance-form/step1-validator";
import {GENDERS} from "@constants/dropdown-choices";
import {showValidationErrorsModal} from "@utils/modal-manager";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step1(
   {
      data,
      handlers,
      setCurrentStep
   }
) {
   
   function onNextBtnClick() {
      
      let validationResult = ValidateStep1Data(data);
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         setCurrentStep(2);
      }
      
      
   }
   
   function onPrevBtnClick() {
      setCurrentStep(0);
   }
   
   return (
      <div className={'if-step-1'}>
         
         <SectionHeading
            text="About You"
         />
         
         <div className="row">
            
            {/* Title */}
            
            {/*<ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 col-md-4"
                    labelText="Title"
                    required={true}
                    controlName="title"
                    options={TITLE_OPTIONS}
                    selectedValues={data.title}
                    onChange={handlers.onControlChange}
                />*/}
            
            {/* Title */}
            
            <ScrollableDropdownBlock
               controlName="title"
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Title"
               required={true}
               options={TITLE_OPTIONS_WITH_PLACEHOLDER}
               selectedValues={data.title}
               onChange={handlers.onControlChange}
               helpText=""
            />
            
            {/* First name */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="First name"
               required={true}
               controlName="firstName"
               value={data.firstName}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Last name */}
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Last name"
               required={true}
               controlName="lastName"
               value={data.lastName}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
         
         </div>
         
         {/* Email, phone and DOB */}
         
         <div className="row name-block">
            
            
            {/* Email */}
            
            <ScrollableTextBoxBlock
               type="email"
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Email"
               required={true}
               controlName="email"
               value={data.email}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Phone */}
            
            <ScrollableTextBoxBlock
               type="tel"
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Phone"
               required={true}
               controlName="phone"
               value={data.phone}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Date of birth */}
            
            <ScrollableCustomDateTimePickerBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Date of birth"
               required={true}
               controlName="birthDate"
               value={data.birthDate}
               onChange={handlers.onControlChange}
               useSplitDate={true}
            />
         
         
         </div>
         
         {/*
                Is born in UK?
            */}
         
         <div className="row">
            
            {/* Were you born in UK?  */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 "
               labelText="Were you born in UK? "
               required={true}
               controlName="isBornInUk"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.isBornInUk}
               onChange={handlers.onControlChange}
            />
         
         </div>
         
         {data.isBornInUk === 'No' && (
            <div className="row hidden-box">
               
               {/* When did you last become a UK resident? */}
               
               <ScrollableCustomDateTimePickerBlock
                  containerCssClass="col-12 py-3 "
                  labelText="When did you last become a UK resident?"
                  required={true}
                  controlName="lastDateBecameUKResident"
                  value={data.lastDateBecameUKResident}
                  onChange={handlers.onControlChange}
               />
            </div>
         
         )}
         
         {/* Gender and Marital status */}
         
         <div className="row">
            
            {/* Gender */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Gender"
               required={true}
               controlName="gender"
               options={GENDERS}
               selectedValues={data.gender}
               onChange={handlers.onControlChange}
            />
            
            <ScrollableDropdownBlock
               controlName="maritalStatus"
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Marital status"
               required={true}
               options={MARITAL_STATUS_OPTIONS}
               selectedValues={data.maritalStatus}
               onChange={handlers.onControlChange}
               helpText=""
            />
         
         </div>
         
         
         <div className="row address-block">
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="House number"
               required={true}
               controlName="houseNumber"
               value={data.houseNumber}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Street address"
               required={true}
               controlName="addressLine1"
               value={data.addressLine1}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Address line 2"
               required={false}
               controlName="addressLine2"
               value={data.addressLine2}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 50
               }}
            />
         
         
         </div>
         
         <div className="row other-block">
            
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Post code"
               required={true}
               controlName="postCode"
               value={data.postCode}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 10
               }}
            />
         
         
         </div>
         
         
         {/*<div className="row">

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3"
                    labelText="Are you home owner?"
                    required={true}
                    controlName="isHomeOwner"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isHomeOwner}
                    onChange={handlers.onControlChange}
                />

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3"
                    labelText="Do you have children under 16 years old?"
                    required={true}
                    controlName="hasChildrenUnder16"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.hasChildrenUnder16}
                    onChange={handlers.onControlChange}
                />

            </div>*/}
         
         
         <SectionHeading
            text="About your employment"
         />
         
         <div className="row">
            <ScrollableDropdownBlock
               controlName="employmentStatus"
               containerCssClass="col-12 py-3 col-md-4"
               labelText="Employment status"
               required={true}
               options={EMPLOYMENT_STATUS_OPTIONS}
               selectedValues={data.employmentStatus}
               onChange={handlers.onControlChange}
               helpText=""
            />
         </div>
         
         {isEmployed(data.employmentStatus) && (
            <div className="row pb-3 mb-3 hidden-box p-3">
               
               
               <ScrollableTextBoxBlock
                  containerCssClass="col-12 py-3 col-md-6"
                  labelText="Occupation"
                  required={true}
                  controlName="mainOccupation"
                  value={data.mainOccupation}
                  onChange={handlers.onControlChange}
                  inputAttrs={{
                     maxLength: 50
                  }}
               />
               
               
               <ScrollableTextBoxBlock
                  containerCssClass="col-12 py-3 col-md-6"
                  labelText="Employer's business"
                  required={true}
                  controlName="occupationIndustry"
                  value={data.occupationIndustry}
                  onChange={handlers.onControlChange}
                  inputAttrs={{
                     maxLength: 50
                  }}
               />
            
            </div>
         )}
         
         <div className="row">
            {/* Do you have an additional job? */}
            
            <ScrollableButtonGroupBlock
               containerCssClass="col-12 py-3"
               labelText="Do you have an additional job?"
               required={true}
               controlName="hasAdditionalJobs"
               options={YES_NO_CHOICE_OPTIONS}
               selectedValues={data.hasAdditionalJobs}
               onChange={handlers.onControlChange}
            />
         </div>
         
         {/*<SectionHeading
                text="How Can We Contact You?"
            />*/}
         
         {/* <div className="row">
                 Are you happy to be contacted about this quote?

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Are you happy to be contacted about this quote?"
                    required={true}
                    controlName="canBeContactedForThisQuote"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.canBeContactedForThisQuote}
                    onChange={handlers.onControlChange}
                />
            </div>*/}
         
         {/*{data.canBeContactedForThisQuote === 'Yes' && (
                <div className="row hidden-box">

                    <ScrollableTextBoxBlock
                        type="email"
                        containerCssClass="col-12 py-3 col-md-6"
                        labelText="Contact email"
                        required={true}
                        controlName="contactEmail"
                        value={data.contactEmail}
                        onChange={handlers.onControlChange}
                        inputAttrs={{
                            maxLength: 50
                        }}
                    />

                    <ScrollableTextBoxBlock
                        type="tel"
                        containerCssClass="col-12 py-3 col-md-6"
                        labelText="Contact phone"
                        required={true}
                        controlName="contactPhone"
                        value={data.contactPhone}
                        onChange={handlers.onControlChange}
                        inputAttrs={{
                            maxLength: 50
                        }}
                    />

                </div>
            )}*/}
         
         
         {/* <div className="row">
                 Are you happy to be contacted so that we can keep you informed about our insurance products, services and offers?

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Are you happy to be contacted so that we can keep you informed about our insurance products, services and offers?"
                    required={true}
                    controlName="canBeContactedForProductsAndServices"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.canBeContactedForProductsAndServices}
                    onChange={handlers.onControlChange}
                />
            </div>*/}
         
         
         <WizardStepButtonsBlock
            onPrevBtnClick={onPrevBtnClick}
            onNextBtnClick={onNextBtnClick}
            nextButtonAdditionalCssClass={``}
         />
      
      
      </div>
   )
}